export class BaseResponseDTO {

  constructor(obj?: any) {
    Object.assign(this, obj);
  }

}
